<template>
    <!-- 如果包含子项集合 -->
    <Submenu v-if="hasChildren(item)"  :name="item.name" :key="item.id">
        <!-- 子菜单的 标题 -->
        <template slot="title">
            <Icon :type="item.icon" size=14 v-if="hasIcon(item)" style="margin-top:-4px"></Icon>
            <span class="layout-text" :key="'title' + item.name">{{item.title}}</span>  
        </template>
        <!-- 子菜单列表 -->
        <template v-for="child in item.children">
            <MenuItem :name="child.name" :key='child.id' v-if="!hasChildren(child)">
                <Icon :type="child.icon" size=14 style="margin-top:-4px"></Icon>
                <span class="layout-text">{{ child.title }}</span> 
            </MenuItem>
            <SubSideBar :key="child.id" :item='child' v-else/>
        </template>
    </Submenu>
</template>

<script>

import {mixins} from './sider'

export default {
    props:['item'],
    name:'SubSideBar',
    mixins:[mixins],
    
}
</script>